const CalendarType = {
    Standard: 'standard',
    Practitioner: 'practitioner',
    Location: 'location',
}

export default CalendarType
